module.exports = __webpack_public_path__ + "img/operation-icon.d6ba8a27.svg";